import { toast } from "sonner";

// Sharing a finished game (Jack, 2026-10-19). The /g/<id> link gives chat
// apps a preview of the game (Vercel passes it to the server), then opens
// the step-through, which anyone can see once a game is finished.
export function gameLink(matchId) {
  const here = typeof window !== "undefined" ? window.location.origin : "";
  const origin = /^https:\/\/(www\.)?playjangle\.com$/.test(here) ? here : "https://playjangle.com";
  return `${origin}/g/${matchId}`;
}

export async function shareGame({ matchId, title, text }) {
  const url = gameLink(matchId);
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (e) {
      if (e?.name === "AbortError") return; // closed the share sheet
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied. Paste it into any chat.");
  } catch {
    window.prompt("Copy this link to share the game", url);
  }
}
